export type WizardStepStatus = 'current' | 'completed' | 'warning' | 'pending'

export function getWizardStepStatus({
  itemStep,
  currentStep,
  visitedSteps,
  isStepValid,
}: {
  itemStep: number
  currentStep: number
  visitedSteps: Set<number>
  isStepValid: (step: number) => boolean
}): WizardStepStatus {
  if (itemStep === currentStep) return 'current'
  // A step is only "completed" once the user has actually visited it.
  if (visitedSteps.has(itemStep) && isStepValid(itemStep)) return 'completed'
  if (visitedSteps.has(itemStep) || itemStep < currentStep) return 'warning'
  return 'pending'
}
